export default __webpack_public_path__ + "static/media/kids-room.f0ff504e.mp4";